/* Shared, DOM-only motif presentation helpers. Never inject merchant text as HTML. */
(function (w) {
  'use strict';
  if (w.FantastickMotifUI) return;
  const F = w.FantastickFavorites;
  function heart(motif) {
    if (!F || !F.isValid(motif.key)) return null;
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'fkm-heart';
    button.dataset.favoriteKey = motif.key; button.dataset.favoriteLabel = motif.label;
    const symbol = document.createElement('span'); symbol.setAttribute('aria-hidden', 'true'); button.append(symbol);
    update(button);
    button.addEventListener('click', event => { event.stopPropagation(); F.toggle(motif.key); });
    return button;
  }
  function update(button) {
    const active = F.has(button.dataset.favoriteKey);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', button.dataset.favoriteLabel + (active ? ' aus Favoriten entfernen' : ' zu Favoriten hinzufügen'));
    button.classList.toggle('is-favorite', active);
    button.firstElementChild.textContent = active ? '♥' : '♡';
  }
  function sync(root) { if (F) root.querySelectorAll('[data-favorite-key]').forEach(update); }
  function picture(motif, sizes) {
    const img = document.createElement('img');
    img.src = motif.thumbnailUrl || motif.imageUrl; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
    if (motif.srcset) { img.srcset = motif.srcset; img.sizes = sizes || '(max-width: 749px) 140px, 170px'; }
    img.width = Number(motif.imageWidth) || 300; img.height = Number(motif.imageHeight) || 300;
    img.draggable = false; return img;
  }
  w.FantastickMotifUI = { heart, sync, picture };
})(window);
